import { render } from "./StorefrontCategoryNav.vue?vue&type=template&id=3ea52334&scoped=true"
import script from "./StorefrontCategoryNav.vue?vue&type=script&lang=js"
export * from "./StorefrontCategoryNav.vue?vue&type=script&lang=js"

import "./StorefrontCategoryNav.vue?vue&type=style&index=0&id=3ea52334&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea52334"]])

export default __exports__